import React from 'react'
import { Award, Users, ChevronRight } from 'react-feather';


const AboutUs = () => {
  const cards = [
    {
      title: "MISSION",
      content: "Lorem ipsum dolor sit amet, quis nostrud adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <ChevronRight size={32} />,
      color: "linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%)"
    },
    {
      title: "VISION",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <Users size={32} />,
      color: "linear-gradient(135deg, #f72585 0%, #b5179e 100%)"
    },
    {
      title: "VALUES",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <Award size={32} />,
      color: "linear-gradient(135deg, #4cc9f0 0%, #4895ef 100%)"
    }
  ];

  return (
    <>
  {/* ======== 2.1. Subpage_Hero section ======== */}
  <section className="Subpage_Hero">
        <div className="container">
          <div className="text-lg-start text-center" data-aos="fade-up">
            <h1>About Us</h1>
            <p>
              We are dedicated to nurturing innovative minds equipped with values, knowledge, 
              and 21st-century skills, ready to thrive in a global society.
            </p>
          </div>
        </div>
      </section>
  {/* ======== End of 2.1. Subpage_Hero section ======== */}


  {/* ======== End of 1.3. About section ========  */}
       <section className="About m-0 d-none">
        <div className="container">
          <div className="row justify-content-between gy-md-0 gy-4">
            <div className="col-lg-4 col-md-5">
              <div
                className="d-flex flex-column justify-content-lg-center h-100 position-relative"
                data-aos="fade-up"
              >
                <h2>Join a Place Where Every Student Should Be</h2>
                <p>
                  Our institution is built on the foundation of innovation, integrity, 
                  and excellence. We provide an environment where students can grow 
                  academically and personally.
                </p>
                <div className="d-flex flex-column gap-lg-4 gap-3 mb-lg-5 mt-lg-3">
                  <div className="d-flex gap-lg-3 gap-2 flex-md-row flex-column align-items-lg-start align-items-center">
                    <figure className="rounded-circle">
                      <img src="assets/images/About/Learning.webp" alt="Learning" />
                    </figure>
                    <div>
                      <h6>Best Learning</h6>
                      <p>Innovative teaching methods tailored for each student.</p>
                    </div>
                  </div>
                  <div className="d-flex gap-lg-3 gap-2 flex-md-row flex-column align-items-lg-start align-items-center">
                    <figure className="rounded-circle">
                      <img src="assets/images/About/Food.webp" alt="Food" />
                    </figure>
                    <div>
                      <h6>Nutritious Food</h6>
                      <p>Healthy meals to fuel young minds and bodies.</p>
                    </div>
                  </div>
                </div>
                <div className="pb-0">
                  <a href="Contact.html" className="hover1">
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-7">
              <div className="d-flex position-relative gap-lg-4 gap-3 align-items-center h-100 flex-sm-row flex-column">
                <div className="d-flex flex-column gap-lg-4 gap-3 w-100 align-items-end h-100 ps-md-0 ps-sm-3">
                  <figure className="w-100" data-aos="flip-left">
                    <img
                      className="w-100"
                      src="assets/images/About/About_img.webp"
                      alt="About_Img"
                    />
                  </figure>
                  <figure className="w-100" data-aos="flip-left">
                    <img
                      className="w-100"
                      src="assets/images/About/about_img2.webp"
                      alt="About_Img"
                    />
                  </figure>
                </div>
                <figure
                  className="mt-lg-5 mt-md-5 pt-lg-5 pt-md-5 w-75"
                  data-aos="flip-left"
                >
                  <img
                    className="w-100"
                    src="assets/images/About/about_img3.webp"
                    alt="About_Img"
                  />
                </figure>
                <div>
                  <img
                    className="bounce-slow"
                    src="assets/images/icon/baloons.svg"
                    alt="baloon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
        {/* ======== End of 1.3. About section ========  */}

            {/* ======== 2.3. Mission section ======== */}
            <section className="Mission d-none">
                  <div className="container">
                    <div className="row flex-md-row flex-column-reverse gy-md-0 gy-4">
                      <div className="col-lg-6 col-md-6">
                        <figure className="w-100 h-100" data-aos="zoom-in-up">
                          <img
                            className="w-100 h-100"
                            src="assets/images/About/mission_img.webp"
                            alt="mission_img"
                          />
                        </figure>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="d-flex flex-column justify-content-between h-100 gap-4">
                          <div
                            className="text-center h-50 d-flex flex-column justify-content-center"
                            data-aos="flip-left"
                          >
                            <h3>Mission</h3>
                            <p>
                              "To offer a transformative education experience through a blend of 
                              conceptual learning, personal development, and future skills."
                            </p>
                          </div>
                          <div
                            className="text-center h-50 d-flex flex-column justify-content-center"
                            data-aos="flip-left"
                          >
                            <h3>Vision</h3>
                            <p>
                              "To nurture innovative minds equipped with values, knowledge, 
                              and 21st-century skills, ready to thrive in a global society."
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="py-5 position-relative overflow-hidden d-none" >
                <div className="container position-relative z-1">
                  <div className="text-center mb-5">
                    <h2 className=" mb-2" style={{color:"#200D46"}}>OUR CORE PRINCIPLES</h2>
                    {/* <div className="d-flex justify-content-center">
                      <div className="divider-line" style={{ 
                        width: '50px', 
                        height: '4px', 
                        background: 'linear-gradient(90deg, #4361ee, #4cc9f0)',
                        borderRadius: '16px'
                      }}></div>
                    </div> */}
                  </div>
                  
                  <div className="row g-4 justify-content-center">
                    {cards.map((card, index) => (
                      <div key={index} className="col-lg-4 col-md-6">
                        <div 
                          className="rounded-4 card-hover-effect d-flex flex-column align-items-center justify-content-center text-center p-4 p-md-5 h-100"
                          style={{ 
                            background: 'white',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                            border: 'none',
                            transition: 'all 0.4s ease',
                            minHeight: '200px',
                            borderRadius:"16px"
                          }}
                        >
                          <div 
                            className="icon-wrapper rounded-circle d-flex align-items-center justify-content-center mb-4"
                            style={{
                              width: '60px',
                              height: '60px',
                              background: card.color
                            }}
                          >
                            <div className="text-white">
                              {card.icon}
                            </div>
                          </div>
                          <h3 className="h4 fw-bold text-dark mb-3">{card.title}</h3>
                          <p className="text-muted mb-0" style={{ lineHeight: '1.6' }}>{card.content}</p>
                          
                          <div 
                            className="mt-2 pt-1 w-100"
                            style={{
                              borderTop: `2px solid ${card.color.split(' ')[4]}`,
                              opacity: 0.7
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
                {/* mission vision  */}
                <section className="ChooseUs">
                  <div className="container position-relative">
                  <div className=" text-center mt-0 mb-3" data-aos="fade-up">
                            <h2 className='h2 display-5 fw-bold'>Practice Based Learning</h2>
                            <p>
                              Lorem ipsum dolor sit amet consectetur
                            </p>
                          </div>                    <div className="row flex-md-row flex-column-reverse gy-md-0 gy-4">
                      <div className="col-lg-6 col-md-6">
                        <figure data-aos="zoom-in-up">
                          <img
                            className="w-100"
                            src="assets/images/About/chooseUs.webp"
                            alt="chooseUs"
                          />
                        </figure>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        
                        <div className="d-flex flex-column ps-lg-4 mt-lg-2 mt-md-2">
                          
                          <div className="mission-vision-container">
                            <div className="d-flex flex-column gap-3">
                              {/* Mission Card */}
                              <div 
                                className="mission-vision-card p-4 rounded-4 shadow-sm"
                                data-aos="fade-up"
                              >
                                <div className="d-flex gap-4 align-items-start">
                                  <div className="icon-container bg-primary bg-opacity-10 p-3 rounded-circle">
                                    <img 
                                      src="assets/images/icon/lab.svg" 
                                      alt="Mission" 
                                      className="icon-img"
                                      style={{ width: '20px', height: '20px' }}
                                    />
                                  </div>
                                  <div className="content-wrapper">
                                    <h4 className="fw-bold text-dark mb-3">OUR MISSION</h4>
                                    <p className="text-muted mb-0">
                                      To nurture innovative minds equipped with values, knowledge, and 21st-century skills, 
                                      ready to thrive in a global society
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* Vision Card */}
                              <div 
                                className="mission-vision-card p-4 rounded-4 shadow-sm"
                                data-aos="fade-up"
                              >
                                <div className="d-flex gap-4 align-items-start">
                                  <div className="icon-container bg-info bg-opacity-10 p-3 rounded-circle">
                                    <img 
                                      src="assets/images/icon/Ruler.svg" 
                                      alt="Vision" 
                                      className="icon-img"
                                      style={{ width: '20px', height: '20px' }}
                                    />
                                  </div>
                                  <div className="content-wrapper">
                                    <h4 className="fw-bold text-dark mb-3">OUR VISION</h4>
                                    <p className="text-muted mb-0">
                                      To offer a transformative education experience through a blend of conceptual learning, 
                                      personal development, and future skills
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div 
                                className="mission-vision-card p-4 rounded-4 shadow-sm"
                                data-aos="fade-up"
                              >
                                <div className="d-flex gap-4 align-items-start">
                                  <div className="icon-container bg-info bg-opacity-10 p-3 rounded-circle">
                                    <img 
                                      src="assets/images/icon/book.svg" 
                                      alt="Vision" 
                                      className="icon-img"
                                      style={{ width: '20px', height: '20px' }}
                                    />
                                  </div>
                                  <div className="content-wrapper">
                                    <h4 className="fw-bold text-dark mb-3">OUR PROMISES</h4>
                                    <p className="text-muted mb-0">
                                    We commit to quality, creativity, and care in shaping every learner's journey.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-lg-5 mt-4" data-aos="fade-up">
                            <a href="Contact.html" className="hover1">
                              Get Started
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                {/* ======== End of 2.3. Mission section ======== */}

                          {/* ======== Core Values Section ======== */}
                            <section className="CoreValues Newsletter py-5">
                            <div className="container">
                              <div className="text-center mb-5" data-aos="fade-up">
                                <h2 className="gradient-text">Our Core Values</h2>
                                <p className="text-muted">The foundation of everything we do</p>
                              </div>

                              <div className="row justify-content-center gap-3 gap-lg-4">
                            {[
                              {
                                title: "Innovation",
                                description: "Embracing creativity and new approaches to learning",
                                icon: "fa-lightbulb",
                                color: "#4a6bff",
                              },
                              {
                                title: "Integrity",
                                description: "Upholding the highest ethical standards in all we do",
                                icon: "fa-shield-alt",
                                color: "#6c5ce7",
                              },
                              {
                                title: "Excellence",
                                description: "Striving for the highest quality in education and beyond",
                                icon: "fa-award",
                                color: "#00b894",
                              },
                              {
                                title: "Collaboration",
                                description: "Working together to achieve common goals team ",
                                icon: "fa-users",
                                color: "#fd79a8",
                              },
                              {
                                title: "Growth Mindset",
                                description: "Believing in continuous improvement and development",
                                icon: "fa-seedling",
                                color: "#fdcb6e",
                              },
                            ].map((value, index) => (
                              <div
                                key={index}
                                className="col-6 col-sm-4 col-md-3 col-lg-auto d-flex justify-content-center"
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                              >
                                <div
                                  style={{
                                    width: "182px",
                                    minHeight: "200px",
                                    padding: "16px",
                                    borderRadius: "12px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    display: "flex",
                                    flexDirection: "column",
                                    // justifyContent: "space-between",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-5px)";
                                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "none";
                                    e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.08)";
                                  }}
                                >
                                  <div style={{ color: value.color }}>
                                    <i className={`fas ${value.icon} fa-2x mt-3`} />
                                  </div>
                                  <div>
                                    <h6 className="fw-bold mt-3 mb-0" style={{ fontSize: "14px" }}>
                                      {value.title}
                                    </h6>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: "#555",
                                        padding:"10px",
                                        lineHeight: "1.5",
                                        fontWeight:"bold",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      {value.description}
                                    </p>
                                  </div>
                                  <div
                                    style={{
                                      height: "3px",
                                      width: "30px",
                                      backgroundColor: value.color,
                                      borderRadius: "2px",
                                      margin: "0 auto",
                                    }}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>

                            </div>
                          </section>
                          {/* ======== End of Core Values Section ======== */}
                    {/* ======== 2.2. Stats section ======== */}
                    <section className="Stats ">
                            <div className="container">
                              <div className="text-center" data-aos="fade-up">
                                <h5>We Are in Numbers</h5>
                                <div className="d-flex justify-content-center align-items-center flex-md-row flex-column">
                                  <div className="d-flex justify-content-center align-items-center text-center flex-column">
                                    <h2>
                                      <span className="number" data-final-value={10} />
                                      k+
                                    </h2>
                                    <p>Years of Transformative Learning</p>
                                  </div>
                                  <hr />
                                  <div className="d-flex justify-content-center align-items-center text-center flex-column">
                                    <h2>
                                      <span className="number" data-final-value={500} />
                                      k+
                                    </h2>
                                    <p>Happy Students and Growing</p>
                                  </div>
                                  <hr />
                                  <div className="d-flex justify-content-center align-items-center text-center flex-column">
                                    <h2>
                                      <span className="number" data-final-value={20} />
                                      k+
                                    </h2>
                                    <p>Passionate and Certified Educators</p>
                                  </div>
                                  <hr />
                                  <div className="d-flex justify-content-center align-items-center text-center flex-column">
                                    <h2>
                                      <span className="number" data-final-value={50} />
                                      k+
                                    </h2>
                                    <p>Prestigious Awards for Excellence</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>

                        {/* ======== End of 2.2. Stats section ======== */}

                                  {/* ======== Leadership Section ======== */}
                                  <section className="Timeline  py-5">
                        <div className="container">
                          <div className="text-center mb-5" data-aos="fade-up">
                            <h2 className=" mb-2" style={{color:"#200D46"}}>Our Journey</h2>
                            <p className="text-muted">DNET Schools began with a dream to redefine rural and urban education through innovation. From one visionary institution to a growing family of excellence, our journey has been fueled by purpose-driven programs like Parvam, Yummy Learning, and Innoflip. Today, DNET is known for producing thinkers, creators, and achievers.</p>
                          </div>
                          <div className="timeline-wrapper">
                            <div className="timeline">
                              {[
                                {
                                  year: "2005",
                                  title: "Inception",
                                  description: "Founded with a vision to revolutionize education",
                                  icon: "fa-lightbulb",
                                  img: "assets/images/Moments/moments_1.webp",
                                  color: "#4a6bff"
                                },
                                {
                                  year: "2010",
                                  title: "First Expansion",
                                  description: "Opened second campus to serve growing community needs",
                                  icon: "fa-building",
                                  img: "assets/images/Moments/moments_2.webp",
                                  color: "#6c5ce7"
                                },
                                {
                                  year: "2015",
                                  title: "Parvam Program",
                                  description: "Launched our flagship holistic development program",
                                  icon: "fa-star",
                                  img: "assets/images/Moments/moments_3.webp",
                                  color: "#00b894"
                                },
                                {
                                  year: "2018",
                                  title: "Yummy Learning",
                                  description: "Introduced nutrition-focused learning initiative",
                                  icon: "fa-utensils",
                                  img: "assets/images/Moments/moments_4.webp",
                                  color: "#fd79a8"
                                },
                                {
                                  year: "2022",
                                  title: "Global Recognition",
                                  description: "Awarded International School of Excellence",
                                  icon: "fa-trophy",
                                  img: "assets/images/Moments/moments_5.webp",
                                  color: "#fdcb6e"
                                }
                              ].map((item, index) => (
                                <div 
                                  className="timeline-item" 
                                  key={index} 
                                  data-aos="zoom-in" 
                                  data-aos-delay={index * 150}
                                >
                                  <div className="timeline-content">
                                    <div 
                                      className="timeline-year" 
                                      style={{ background: item.color }}
                                    >
                                      <i className={`fas ${item.icon}`} />
                                      <span>{item.year}</span>
                                    </div>
                                    <div className="timeline-body text-center ">
                                      <h4 className="timeline-title">{item.title}</h4>
                                      <p className="timeline-desc">{item.description}</p>
                                      {item.img && (
                                        <div className="timeline-image-container">
                                          <img 
                                            src={item.img} 
                                            alt={item.title} 
                                            className="timeline-image"
                                            loading="lazy"
                                          />
                                          <div className="image-overlay" style={{ background: item.color }} />
                                        </div>
                                      )}
                                      <div className="timeline-progress" style={{ background: item.color }} />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                                </section>
                              {/* ======== 1.8. Teachers section ========  */}

                              <section className="Teachers pt-0 d-none">
                                <div className="container">
                                  <div
                                    className="d-flex justify-content-center align-items-center text-center flex-column mx-auto"
                                    data-aos="fade-up"
                                  >
                                    <h2>Experienced Teachers</h2>
                                    <p>
                                      Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                                      aliquet cursus mauris ut. Enim fermentum maecenas rutrum dapibus
                                      sodales quis.
                                    </p>
                                  </div>
                                  <div className="row gy-sm-0 gy-4">
                                    <div className="col-lg-4 col-md-4 col-sm-4">
                                      <div
                                        className="position-relative overflow-hidden"
                                        data-aos="flip-left"
                                      >
                                        <figure>
                                          <img
                                            className="rounded-circle w-100"
                                            src="assets/images/About/teacher_1.webp"
                                            alt="teacher_1"
                                          />
                                        </figure>
                                        <div className="position-absolute text-center h-100 w-100 flex-column align-items-center justify-content-center">
                                          <h3>Diyana</h3>
                                          <p>CEO</p>
                                          <div className="d-flex justify-content-center gap-2 align-items-center">
                                            <a href="#">
                                              <i className="fab fa-facebook-f" />
                                            </a>
                                            <a href="#">
                                              <i className="fab fa-linkedin-in" />
                                            </a>
                                            <a href="#">
                                              <i className="fab fa-pinterest-p" />
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4">
                                      <div
                                        className="position-relative overflow-hidden"
                                        data-aos="flip-left"
                                      >
                                        <figure>
                                          <img
                                            className="rounded-circle w-100"
                                            src="assets/images/About/teacher_2.webp"
                                            alt="teacher_2"
                                          />
                                        </figure>
                                        <div className="position-absolute text-center h-100 w-100 flex-column align-items-center justify-content-center">
                                          <h3>Jhon</h3>
                                          <p>Teacher</p>
                                          <div className="d-flex justify-content-center gap-2 align-items-center">
                                            <a href="#">
                                              <i className="fab fa-facebook-f" />
                                            </a>
                                            <a href="#">
                                              <i className="fab fa-linkedin-in" />
                                            </a>
                                            <a href="#">
                                              <i className="fab fa-pinterest-p" />
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-4">
                                      <div
                                        className="position-relative overflow-hidden"
                                        data-aos="flip-left"
                                      >
                                        <figure>
                                          <img
                                            className="rounded-circle w-100"
                                            src="assets/images/About/teacher_3.webp"
                                            alt="teacher_3"
                                          />
                                        </figure>
                                        <div className="position-absolute text-center h-100 w-100 flex-column align-items-center justify-content-center">
                                          <h3>Watson</h3>
                                          <p>Professor</p>
                                          <div className="d-flex justify-content-center gap-2 align-items-center">
                                            <a href="#">
                                              <i className="fab fa-facebook-f" />
                                            </a>
                                            <a href="#">
                                              <i className="fab fa-linkedin-in" />
                                            </a>
                                            <a href="#">
                                              <i className="fab fa-pinterest-p" />
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-center" data-aos="fade-up">
                                    <a href="Team.html" className="hover1">
                                      View All Teachers
                                    </a>
                                  </div>
                                </div>
                              </section>
</>

  )
}

export default AboutUs
